var _react_refresh_temp_1;
var _react_refresh_temp_2;
_react_refresh_temp_2 = $RefreshSig$();
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useLayoutEffect, useRef, useState } from 'react';
import { C } from '#integrations';
import { Box } from '../../Box';
import { ChevronRightIcon } from '../../icons';
import { BreadcrumbTestIdFactory } from '../interactions';
import styles from './BreadcrumbLink.module.css';
// Max link text width is 256px - 16px hard drive icon - 8px gap
const MAX_TEXT_WIDTH = 232;
export const BreadcrumbLink = ({ 'data-testid': testId, entry, isCurrent, isRoot, LeadingIcon, onSelect, shouldTruncateRoot, textField, }) => {
    _react_refresh_temp_2();
    const [isTooLong, setIsTooLong] = useState(false);
    const textRef = useRef(null);
    useLayoutEffect(() => {
        const textWidth = textRef.current?.scrollWidth;
        if (textWidth !== undefined) {
            setIsTooLong(textWidth > MAX_TEXT_WIDTH);
        }
    }, []);
    if (!entry) {
        return null;
    }
    if (isCurrent) {
        return (_jsxs(Box, { className: styles.Current, "data-testid": BreadcrumbTestIdFactory.getBreadcrumbLinkTestId(testId), gap: "s", children: [isRoot && _jsx(LeadingIcon, { color: "accent", size: "xsmall" }), _jsx("span", { className: C(styles.LinkText, styles.LinkTextEllipsis), title: entry[textField], children: entry[textField] })] }));
    }
    else {
        return (_jsxs(_Fragment, { children: [_jsxs("a", { className: C(styles.Link, isRoot &&
                        !isTooLong &&
                        !shouldTruncateRoot &&
                        styles.LinkNoEllipsis), "data-testid": BreadcrumbTestIdFactory.getBreadcrumbLinkTestId(testId), href: "#", onClick: (e) => {
                        e.preventDefault();
                        onSelect(entry);
                    }, title: entry[textField], children: [isRoot && _jsx(LeadingIcon, { size: "xsmall" }), _jsx("span", { className: C(styles.LinkText, isRoot && !isTooLong && !shouldTruncateRoot
                                ? styles.LinkTextNoEllipsis
                                : styles.LinkTextEllipsis), ref: textRef, children: entry[textField] })] }), _jsx(ChevronRightIcon, { size: "xsmall" })] }));
    }
};
_react_refresh_temp_1 = BreadcrumbLink;
$RefreshReg$(_react_refresh_temp_1, "BreadcrumbLink");
_react_refresh_temp_2(BreadcrumbLink, "8KEGP0slwDX8PUMMEsnCPvZST+s=");
